module.exports = __webpack_public_path__ + "img/gold_level4.31611033.png";